module.exports = __webpack_public_path__ + "b8fed0ea202da299199cd4fe85e0f6ab.png";


//////////////////
// WEBPACK FOOTER
// ./assets/img/ponytones.png
// module id = 39
// module chunks = 1